import { sessionView } from "../../lib/bandung/api/session";
import {clearSession} from "../../lib/bandung/bandung";
import {redirect} from "react-router-dom";
import {testSessionLoader} from "../../lib/bandung/loaders/helpers";

export const contactLoader = async () => {
  await (() => setTimeout(null, 1));
  const userEntityRes = await sessionView();
  return { userEntityRes };
};

export const testAdminLoader = async (params) => {
  await testSessionLoader(params);

  const userEntityRes = await sessionView();
  const userEntity = userEntityRes.data;

  if ( !userEntity.administrator ) {
    clearSession();
    const message = "You must sign in as Admin before continue.";
    const url = new URL(params?.request?.url);
    const pathname = url.pathname;
    throw redirect(`/signin?message=${message}&redirect=${pathname}`);
  }
  return userEntityRes;
};
